import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import SmartNewsRelatedArticles from "../packs/smart_news_related_articles"
import ContentPreview from "../packs/content_preview"

const application = Application.start()
const context = require.context(".", true, /\.js$/)
application.load(definitionsFromContext(context))

// 明示的にコントローラーを登録
application.register("smart-news-related-articles", SmartNewsRelatedArticles)
application.register("content-preview", ContentPreview)
